import React from 'react';
import { motion } from 'framer-motion';

const fadeIn = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6 }
};

const PageHeader = ({ title, description, backgroundImage }) => {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0">
        {backgroundImage && (
          <img
            src={backgroundImage}
            alt="Background"
            className="w-full h-full object-cover opacity-20"
          />
        )}
        <div className="absolute inset-0 bg-[#dbc582]/30 mix-blend-multiply" />
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial="initial"
          animate="animate"
          variants={fadeIn}
          className="text-center"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {title}
          </h1>
          {description && (
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
              {description}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHeader;
